import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withResolvePaths } from "../../withResolvePaths";
import { AbsoluteResolvedModelPath, AbsoluteModelPath, ModelPathImpl } from "../../../../../Common/ModelPath/ModelPath";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";

import { InstanceNumber, InstanceNumberProps } from "./InstanceNumber";
import { addInstanceNumber, removeInstanceNumber } from "./Store/instanceNumberActionCreators";

interface InstanceNumberContainerProps extends Omit<InstanceNumberProps, "instanceIndex" | "parentInstanceNumber"> {
    bindingPath: AbsoluteResolvedModelPath;
    notResolvedBindingPath: AbsoluteModelPath;
}

const mapStateToProps = (
    state: FullFormState,
    ownProps: InstanceNumberContainerProps
): Pick<InstanceNumberProps, "parentInstanceNumber"> => {
    const { bindingPath, notResolvedBindingPath } = ownProps;

    const pathWithoutLastIteration = notResolvedBindingPath.getPathWithoutLastIteration();
    const parentIterationIndex = pathWithoutLastIteration.getLastIndexOfCurrentOrEachIteration();
    const pathContainsParentIteration = parentIterationIndex !== -1;

    const resolvedTokens = bindingPath.getPathPartsAsArray();
    let parentInstanceNumber = undefined;
    if (pathContainsParentIteration) {
        const parentInstancePathTokens = resolvedTokens.slice(0, parentIterationIndex + 1);
        const parentInstancePath = new ModelPathImpl(parentInstancePathTokens, true).toString();
        parentInstanceNumber = state.instanceNumber?.[parentInstancePath];
    }

    return {
        parentInstanceNumber: parentInstanceNumber,
    };
};

export const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: InstanceNumberContainerProps) => {
    const { bindingPath } = ownProps;
    const stringBindingPath = bindingPath.toString();

    return {
        onInstanceNumberAdded: (instanceNumber: number) => {
            dispatch(addInstanceNumber(stringBindingPath, instanceNumber));
        },
        onInstanceNumberRemoved: () => {
            dispatch(removeInstanceNumber(stringBindingPath));
        },
    };
};

export const InstanceNumberContainer = withResolvePaths(connect(mapStateToProps, mapDispatchToProps)(InstanceNumber));
